// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23555%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-subscription-container {
    max-width: 700px;
    margin: 40px auto;
    padding: 40px;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
  }
  
  .manage-subscription-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(90deg, rgb(53, 73, 94) 0%, rgb(78, 104, 131) 100%);
  }
  
  .manage-subscription-header {
    margin-bottom: 35px;
    text-align: center;
    position: relative;
  }
  
  .manage-subscription-header h1 {
    color: rgb(53, 73, 94);
    margin-bottom: 15px;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: -0.5px;
  }
  
  .subscription-status {
    font-size: 15px;
    padding: 8px 18px;
    border-radius: 30px;
    display: inline-block;
    margin-top: 10px;
    font-weight: 500;
    letter-spacing: 0.2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s;
  }
  
  .subscription-status:hover {
    transform: translateY(-2px);
  }
  
  .subscription-status.active {
    background-color: #e8f7ec;
    color: #1e8e3e;
  }
  
  .subscription-status.inactive {
    background-color: #fceef0;
    color: #d93025;
  }
  
  .subscription-form-container {
    margin-top: 25px;
    position: relative;
  }
  
  .form-group {
    margin-bottom: 28px;
    position: relative;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 10px;
    font-weight: 600;
    color: #333;
    font-size: 15px;
    letter-spacing: 0.2px;
    transition: color 0.2s;
  }
  
  .form-group:focus-within label {
    color: rgb(53, 73, 94);
  }
  
  .form-group input,
  .form-group select {
    width: 100%;
    padding: 14px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: all 0.3s;
    background-color: #f9f9fa;
  }
  
  .form-group input:hover,
  .form-group select:hover {
    border-color: #ccc;
  }
  
  .form-group input:focus,
  .form-group select:focus {
    border-color: rgb(53, 73, 94);
    outline: none;
    box-shadow: 0 0 0 4px rgba(53, 73, 94, 0.1);
    background-color: #fff;
  }
  
  .disabled-input {
    background-color: #f2f3f4 !important;
    cursor: not-allowed;
    color: #777;
  }
  
  .category-checkboxes {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 15px;
    /* margin-top: 12px; */
    padding: 5px;
  }
  
  .category-checkbox {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .category-checkbox input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    cursor: pointer;
    position: relative;
    top: -1px;
  }
  
  .category-checkbox label {
    cursor: pointer;
    font-weight: 400;
    margin-bottom: 0;
    font-size: 14px;
  }
  
  .form-actions {
    display: flex;
    gap: 16px;
    margin-top: 35px;
  }
  
  .update-button,
  .unsubscribe-button {
    padding: 14px 24px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s;
    border: none;
    letter-spacing: 0.3px;
    position: relative;
    overflow: hidden;
  }
  
  .update-button::after
  {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));
    opacity: 0;
    transition: opacity 0.25s;
  }
  
  .update-button:hover::after{
    opacity: 1;
  }
  
  .update-button {
    background-color: rgb(53, 73, 94);
    color: white;
    flex: 2 1;
    box-shadow: 0 4px 12px rgba(53, 73, 94, 0.2);
  }
  
  .update-button:hover {
    background-color: rgb(60, 82, 105);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(53, 73, 94, 0.25);
  }
  
  .update-button:active {
    transform: translateY(1px);
  }
  
  .unsubscribe-button {
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    color: #d93025;
    flex: 1 1;
    transition: all 0.25s;
  }
  
  .unsubscribe-button:hover {
    background-color: #fef8f8;
    border-color: #ffcdd2;
    color: #c62828;
  }

  
  .message {
    padding: 16px 20px;
    border-radius: 8px;
    margin-bottom: 25px;
    font-size: 15px;
    display: flex;
    align-items: center;
    position: relative;
    animation: messageAppear 0.3s ease;
  }
  
  @keyframes messageAppear {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .message::before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 12px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  
  .message.success {
    background-color: #e9f7ec;
    color: #1e8e3e;
    border-left: 4px solid #1e8e3e;
  }
  
  .message.success::before {
    content: '✓';
    color: #1e8e3e;
    font-weight: bold;
  }
  
  .message.error {
    background-color: #fceef0;
    color: #d93025;
    border-left: 4px solid #d93025;
  }
  
  .message.error::before {
    content: '!';
    color: #d93025;
    font-weight: bold;
  }
  
  .loading-spinner {
    text-align: center;
    padding: 60px 0;
    color: #666;
    font-size: 16px;
    position: relative;
  }
  
  .loading-spinner::after {
    content: '';
    display: block;
    width: 40px;
    height: 40px;
    margin: 20px auto 0;
    border-radius: 50%;
    border: 3px solid rgb(53, 73, 94);
    border-top-color: transparent;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  .subscribe-prompt {
    text-align: center;
    padding: 30px 0;
  }
  
  .subscribe-prompt p {
    margin-bottom: 25px;
    color: #555;
    font-size: 16px;
    line-height: 1.6;
  }
  
  /* Custom select styling */
  select {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 40px !important;
  }
  
  /* Focus highlight effect for interactive elements */
  input:focus, select:focus, button:focus {
    outline: none;
  }
  
  @media (max-width: 768px) {
    .manage-subscription-container {
      padding: 30px 20px;
      margin: 20px;
      border-radius: 10px;
    }
    
    .manage-subscription-header h1 {
      font-size: 24px;
    }
    
    .form-actions {
      flex-direction: column;
    }
    
    .update-button, 
    .unsubscribe-button {
      width: 100%;
    }
    
    .category-checkboxes {
      grid-template-columns: 1fr;
    }
  }`, "",{"version":3,"sources":["webpack://./src/ManageSubscription.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,8EAA8E;EAChF;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,yCAAyC;IACzC,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,6BAA6B;IAC7B,aAAa;IACb,2CAA2C;IAC3C,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,6EAA6E;IAC7E,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,YAAY;IACZ,SAAO;IACP,4CAA4C;EAC9C;;EAEA;IACE,kCAAkC;IAClC,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,SAAO;IACP,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;;EAGA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,yDAA8R;IAC9R,4BAA4B;IAC5B,sCAAsC;IACtC,8BAA8B;EAChC;;EAEA,oDAAoD;EACpD;IACE,aAAa;EACf;;EAEA;IACE;MACE,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;;MAEE,WAAW;IACb;;IAEA;MACE,0BAA0B;IAC5B;EACF","sourcesContent":[".manage-subscription-container {\n    max-width: 700px;\n    margin: 40px auto;\n    padding: 40px;\n    background-color: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .manage-subscription-container::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    background: linear-gradient(90deg, rgb(53, 73, 94) 0%, rgb(78, 104, 131) 100%);\n  }\n  \n  .manage-subscription-header {\n    margin-bottom: 35px;\n    text-align: center;\n    position: relative;\n  }\n  \n  .manage-subscription-header h1 {\n    color: rgb(53, 73, 94);\n    margin-bottom: 15px;\n    font-size: 32px;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n  }\n  \n  .subscription-status {\n    font-size: 15px;\n    padding: 8px 18px;\n    border-radius: 30px;\n    display: inline-block;\n    margin-top: 10px;\n    font-weight: 500;\n    letter-spacing: 0.2px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    transition: transform 0.2s;\n  }\n  \n  .subscription-status:hover {\n    transform: translateY(-2px);\n  }\n  \n  .subscription-status.active {\n    background-color: #e8f7ec;\n    color: #1e8e3e;\n  }\n  \n  .subscription-status.inactive {\n    background-color: #fceef0;\n    color: #d93025;\n  }\n  \n  .subscription-form-container {\n    margin-top: 25px;\n    position: relative;\n  }\n  \n  .form-group {\n    margin-bottom: 28px;\n    position: relative;\n  }\n  \n  .form-group label {\n    display: block;\n    margin-bottom: 10px;\n    font-weight: 600;\n    color: #333;\n    font-size: 15px;\n    letter-spacing: 0.2px;\n    transition: color 0.2s;\n  }\n  \n  .form-group:focus-within label {\n    color: rgb(53, 73, 94);\n  }\n  \n  .form-group input,\n  .form-group select {\n    width: 100%;\n    padding: 14px 16px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    font-size: 15px;\n    transition: all 0.3s;\n    background-color: #f9f9fa;\n  }\n  \n  .form-group input:hover,\n  .form-group select:hover {\n    border-color: #ccc;\n  }\n  \n  .form-group input:focus,\n  .form-group select:focus {\n    border-color: rgb(53, 73, 94);\n    outline: none;\n    box-shadow: 0 0 0 4px rgba(53, 73, 94, 0.1);\n    background-color: #fff;\n  }\n  \n  .disabled-input {\n    background-color: #f2f3f4 !important;\n    cursor: not-allowed;\n    color: #777;\n  }\n  \n  .category-checkboxes {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 15px;\n    /* margin-top: 12px; */\n    padding: 5px;\n  }\n  \n  .category-checkbox {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  .category-checkbox input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    margin-right: 10px;\n    cursor: pointer;\n    position: relative;\n    top: -1px;\n  }\n  \n  .category-checkbox label {\n    cursor: pointer;\n    font-weight: 400;\n    margin-bottom: 0;\n    font-size: 14px;\n  }\n  \n  .form-actions {\n    display: flex;\n    gap: 16px;\n    margin-top: 35px;\n  }\n  \n  .update-button,\n  .unsubscribe-button {\n    padding: 14px 24px;\n    border-radius: 8px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.25s;\n    border: none;\n    letter-spacing: 0.3px;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .update-button::after\n  {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));\n    opacity: 0;\n    transition: opacity 0.25s;\n  }\n  \n  .update-button:hover::after{\n    opacity: 1;\n  }\n  \n  .update-button {\n    background-color: rgb(53, 73, 94);\n    color: white;\n    flex: 2;\n    box-shadow: 0 4px 12px rgba(53, 73, 94, 0.2);\n  }\n  \n  .update-button:hover {\n    background-color: rgb(60, 82, 105);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(53, 73, 94, 0.25);\n  }\n  \n  .update-button:active {\n    transform: translateY(1px);\n  }\n  \n  .unsubscribe-button {\n    background-color: #ffffff;\n    border: 1px solid #e0e0e0;\n    color: #d93025;\n    flex: 1;\n    transition: all 0.25s;\n  }\n  \n  .unsubscribe-button:hover {\n    background-color: #fef8f8;\n    border-color: #ffcdd2;\n    color: #c62828;\n  }\n\n  \n  .message {\n    padding: 16px 20px;\n    border-radius: 8px;\n    margin-bottom: 25px;\n    font-size: 15px;\n    display: flex;\n    align-items: center;\n    position: relative;\n    animation: messageAppear 0.3s ease;\n  }\n  \n  @keyframes messageAppear {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .message::before {\n    content: '';\n    display: block;\n    width: 20px;\n    height: 20px;\n    margin-right: 12px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n  }\n  \n  .message.success {\n    background-color: #e9f7ec;\n    color: #1e8e3e;\n    border-left: 4px solid #1e8e3e;\n  }\n  \n  .message.success::before {\n    content: '✓';\n    color: #1e8e3e;\n    font-weight: bold;\n  }\n  \n  .message.error {\n    background-color: #fceef0;\n    color: #d93025;\n    border-left: 4px solid #d93025;\n  }\n  \n  .message.error::before {\n    content: '!';\n    color: #d93025;\n    font-weight: bold;\n  }\n  \n  .loading-spinner {\n    text-align: center;\n    padding: 60px 0;\n    color: #666;\n    font-size: 16px;\n    position: relative;\n  }\n  \n  .loading-spinner::after {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 40px;\n    margin: 20px auto 0;\n    border-radius: 50%;\n    border: 3px solid rgb(53, 73, 94);\n    border-top-color: transparent;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    to { transform: rotate(360deg); }\n  }\n  \n  .subscribe-prompt {\n    text-align: center;\n    padding: 30px 0;\n  }\n  \n  .subscribe-prompt p {\n    margin-bottom: 25px;\n    color: #555;\n    font-size: 16px;\n    line-height: 1.6;\n  }\n  \n  /* Custom select styling */\n  select {\n    appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23555' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    padding-right: 40px !important;\n  }\n  \n  /* Focus highlight effect for interactive elements */\n  input:focus, select:focus, button:focus {\n    outline: none;\n  }\n  \n  @media (max-width: 768px) {\n    .manage-subscription-container {\n      padding: 30px 20px;\n      margin: 20px;\n      border-radius: 10px;\n    }\n    \n    .manage-subscription-header h1 {\n      font-size: 24px;\n    }\n    \n    .form-actions {\n      flex-direction: column;\n    }\n    \n    .update-button, \n    .unsubscribe-button {\n      width: 100%;\n    }\n    \n    .category-checkboxes {\n      grid-template-columns: 1fr;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
